import { render, staticRenderFns } from "./start-production-dialog.vue?vue&type=template&id=372a341c&scoped=true&"
import script from "./start-production-dialog.vue?vue&type=script&lang=js&"
export * from "./start-production-dialog.vue?vue&type=script&lang=js&"
import style0 from "./start-production-dialog.vue?vue&type=style&index=0&id=372a341c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372a341c",
  null
  
)

export default component.exports